export function getNextSlidePosition(container: HTMLDivElement, targetIndex: number, oldIndex: number) {
  const target = container.childNodes[targetIndex] as HTMLElement | null;
  if (!target) {
    return { offset: 0 };
  }

  const list = Array.from(container.childNodes) as HTMLElement[];

  const { marginRight, marginLeft } = window.getComputedStyle(target, null);
  const leftOffset = marginLeft ? parseInt(marginLeft, 10) : 0;
  const outerOffset = marginRight ? parseInt(marginRight, 10) : 0;
  const offset = target.offsetLeft - leftOffset;

  const elementsPerView = Math.round(container.offsetWidth / (target.offsetWidth + outerOffset));
  const visibleElements = list.slice(targetIndex);

  if (visibleElements.length <= elementsPerView && targetIndex > oldIndex) {
    const lastElementOffset = visibleElements[visibleElements.length - 1].offsetLeft;

    return {
      offset: target.offsetWidth + lastElementOffset + outerOffset - container.offsetWidth,
      isLast: true,
    };
  }

  return { offset };
}
